import type { ShapeType } from '@/lib/shapes/types/shape-type'
import { createRequiredContext } from './create-required-context'

/**
 * Which tool and creation mode the editor is in, with their setters. Changes on a tool switch, not
 * during gestures.
 */
export interface EditorTools {
  /** Left rail tool id: 'select' | 'type' | 'shape' | 'spellcheck' | 'document'. */
  activeItem: string
  setActiveItem: (item: string) => void
  /** Rail activation with home's side effects (deselect, pan-mode exit, etc.). */
  activateTool: (item: string) => void
  /** Shape preset chosen in the Shapes tool, or `null`. */
  selectedShape: ShapeType | null
  setSelectedShape: (shape: ShapeType | null) => void
  selectedPenTool: string | null
  setSelectedPenTool: (tool: string | null) => void
  selectedPointType: string | null
  setSelectedPointType: (type: string | null) => void
  isPanModeActive: boolean
  togglePanMode: () => void
  deactivatePanMode: () => void
  /** True while the canvas is in node-edit mode. */
  isNodeEditMode: boolean
  /** True while the Layout panel's Mirror Move button is hovered (canvas shows a ghost preview). */
  isMirrorMoveHovering: boolean
  setMirrorMoveHovering: (hovering: boolean) => void
}

const editorTools = createRequiredContext<EditorTools>('EditorTools')

export const EditorToolsContext = editorTools.Context
export const EditorToolsProvider = editorTools.Provider
export const useEditorTools = editorTools.useRequiredContext
